import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Agency = {
  id: string;
  name: string;
  owner_id: string | null;
  owner_email: string;
  logo_url: string | null;
  created_at: string;
  updated_at: string;
};

export type UserRole = {
  id: string;
  user_id: string;
  role: 'owner' | 'agency_admin' | 'company_admin';
  agency_id: string | null;
  company_id: string | null;
  created_at: string;
};

export type CompanyLabel = {
  name: string;
  color: number;
  webhook: 1 | 2;
};

export type Company = {
  id: string;
  owner_id: string;
  name: string;
  logo_url: string | null;
  primary_color: string;
  gradient_color: string | null;
  chat_webhook_url: string | null;
  voice_webhook_url: string | null;
  stripe_customer_id: string | null;
  max_seats: number;
  bonus_seats: number;
  voice_enabled: boolean;
  voice_auto_send: boolean;
  trial_ends_at: string | null;
  subscription_status: string;
  owner_email: string | null;
  agency_id: string | null;
  managed_by_company_id: string | null;
  allocated_seats: number;
  encrypted_config: string | null;
  config_iv: string | null;
  config_salt: string | null;
  config_updated_at: string | null;
  master_key_hash: string | null;
  webhook_configured: boolean;
  is_linkable: boolean;
  secondary_webhook_url: string | null;
  webhook_auth: string | null;
  secondary_webhook_auth: string | null;
  labels: CompanyLabel[] | null;
  created_at: string;
  updated_at: string;
};

export type Seat = {
  id: string;
  company_id: string;
  activation_token: string | null;
  employee_name: string | null;
  employee_email: string | null;
  pii_salt: string | null;
  encrypted_employee_name: string | null;
  employee_name_iv: string | null;
  encrypted_employee_email: string | null;
  employee_email_iv: string | null;
  label: string | null;
  group_name: string | null;
  group: string | null;
  status: 'pending' | 'active' | 'inactive';
  activated_at: string | null;
  last_heartbeat: string | null;
  last_seen: string | null;
  device_info: any;
  sync_status: string | null;
  encrypted_token: string | null;
  sync_requested_at: string | null;
  token_used: boolean | null;
  created_at: string;
  updated_at: string;
};

export type Label = {
  id: string;
  company_id: string;
  name: string;
  color: number;
  is_default: boolean;
  is_quick_mode: boolean;
  is_chat_mode: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
};

export type ActivityLog = {
  id: string;
  company_id: string | null;
  user_id: string;
  action: string;
  description: string;
  metadata: Record<string, any>;
  created_at: string;
};

export type ManagedCompany = {
  id: string;
  name: string;
  allocated_seats: number;
  active_seats: number;
  owner_email: string | null;
  logo_url: string | null;
};

